import { isInlineSuggestion } from "@/features/reader/document/blockUtils";
import { useAppState } from "@/store/useApp";

export const usePendingSuggestions = () => {
  const currentDocument = useAppState((state) => state.currentDocument);
  const selectedGroup = useAppState((state) => state.selectedGroup);

  if (!currentDocument || !selectedGroup) return [];

  // Filter pending suggestions
  const filtered = currentDocument.suggestions.filter((suggestion) => {
    if (suggestion.status !== "pending") return false;

     // If document contains single group, include suggestions with no block references (entire document)
     if (currentDocument.groups.length === 1 && suggestion.blocks.length === 0) {
      return true;
    }

    // Include suggestions that have at least one block in the current group
    return (
      !isInlineSuggestion(suggestion) &&
      suggestion.blocks.some((blockId) =>
        selectedGroup.blockIds.includes(blockId)
      )
    );
  });

  // Sort as requested:
  // 1) Positive sentiment suggestions first
  // 2) Suggestions with blocks before those without any blocks
  return filtered.sort((a, b) => {
    const aIsPositive = a.sentiment === "positive";
    const bIsPositive = b.sentiment === "positive";
    if (aIsPositive !== bIsPositive) return aIsPositive ? -1 : 1;

    const aHasBlocks = a.blocks.length > 0;
    const bHasBlocks = b.blocks.length > 0;
    if (aHasBlocks !== bHasBlocks) return aHasBlocks ? -1 : 1;

    return 0;
  });
};
